import script from "./HelloWorldTst.vue?vue&type=script&setup=true&lang=js"
export * from "./HelloWorldTst.vue?vue&type=script&setup=true&lang=js"

import "./HelloWorldTst.vue?vue&type=style&index=0&id=6b15b124&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b15b124"]])

export default __exports__